import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './store/store';
import './pages/Technum.css';
import './index.css';
import './styles/print.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import reportWebVitals from './reportWebVitals';
import { install as installErrorReporter } from './lib/errorReporter';
import { trackPerf } from './lib/analytics';

// Listens for window.error + unhandledrejection. Today this is console
// fallback only; flipping REACT_APP_SENTRY_DSN turns it into a Sentry pipe
// without touching call sites.
installErrorReporter();

// To enable MSW dev mocks:
//   1. npm install --save-dev msw
//   2. npx msw init public/ --save
//   3. echo 'REACT_APP_USE_MOCKS=true' >> .env.development.local
//   4. Uncomment the block below (CRA's webpack can't tree-shake the
//      'msw/browser' specifier away even behind an env gate, so the import
//      stays commented until the package is installed).
//
// const useMocks = process.env.NODE_ENV === 'development'
//   && process.env.REACT_APP_USE_MOCKS === 'true';
// const mocksReady = useMocks
//   ? import('./mocks/browser').then((m) => m.startMocks()).catch(() => {})
//   : Promise.resolve();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <Provider store={store}>
        <App />
      </Provider>
    </ErrorBoundary>
  </React.StrictMode>
);

// Forward Web Vitals via the analytics chokepoint. Today this lands in GA4;
// when a real telemetry backend exists the swap happens inside trackPerf.
reportWebVitals((metric) => {
  trackPerf(metric.name, metric.name === 'CLS' ? metric.value * 1000 : metric.value, {
    metric_id: metric.id,
    metric_delta: metric.delta,
    event_category: 'Web Vitals',
  });
});
